import { Service } from '@/services/api';
import type { DashboardTemplate, DashboardTemplateCreatePayload } from '@/types/v2/DashboardTemplate';

class DashboardTemplateService extends Service {
  async list(): Promise<DashboardTemplate[]> {
    return this.get<DashboardTemplate[]>('/v1/dashboard-template').then(this.handleResponse);
  }

  async create(payload: DashboardTemplateCreatePayload): Promise<void> {
    return this.post<void>('/v1/dashboard-template', payload).then(this.handleResponse);
  }

  async apply(id: number): Promise<void> {
    return this.post<void>(`/v1/dashboard-template/${id}/apply`, {}).then(this.handleResponse);
  }

  async remove(id: number): Promise<void> {
    return this.delete<void>(`/v1/dashboard-template/${id}`).then(this.handleResponse);
  }
}

export default new DashboardTemplateService();
